import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeroiconsOutlineThumbDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 90,
	height: 90,
	viewBox: "0 0 90 90",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M37.5 52.5L19.635 52.5C18.3568 52.5 17.0997 52.1732 15.9833 51.5508C14.8668 50.9284 13.9279 50.0309 13.2558 48.9436C12.5837 47.8564 12.2006 46.6153 12.1429 45.3384C12.0852 44.0614 12.3549 42.7909 12.9263 41.6475L26.0513 15.3975C26.6743 14.1508 27.6323 13.1023 28.818 12.3697C30.0037 11.6371 31.37 11.2494 32.7638 11.25H47.8275C48.4425 11.25 49.0488 11.325 49.6463 11.475L63.75 15M37.5 52.5V71.25C37.5 73.2391 38.2902 75.1468 39.6967 76.5533C41.1032 77.9598 43.0109 78.75 45 78.75H45.3563C47.2313 78.75 48.75 77.2313 48.75 75.3563C48.747 72.6781 49.5407 70.0596 51.03 67.8338L63.75 48.75L63.75 15M37.5 52.5H45M63.75 15H71.25C73.2391 15 75.1468 15.7902 76.5533 17.1967C77.9598 18.6032 78.75 20.5109 78.75 22.5V45C78.75 46.9891 77.9598 48.8968 76.5533 50.3033C75.1468 51.7098 73.2391 52.5 71.25 52.5H61.875",
		stroke: "#BD000F",
		strokeWidth: 6,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHeroiconsOutlineThumbDown;
